import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { HomeController } from "@shared/src/controllers/home/home.controller";
import { HColor } from '@shared/src/datatypes/HColor';
import { HTags } from '@shared/src/datatypes/HTags';
import { RouteCardItemDto } from '@shared/src/dtos/route/RouteCardItemDto';
import { AlertService } from '@shared/src/public-api';
import { Router } from '@angular/router';
import { MultiSlotInfoDto } from '@shared/src/dtos/address/slots/MultiSlotInfoDto';
import { SlotsController } from '@shared/src/controllers/address/slots/slots.controller';
import { SlotInfoDto } from '@shared/src/dtos/address/slots/SlotInfoDto';
import { fadeInOut } from '@shared/src/animations';

@Component({
    selector: 'shared-active-slots-item-header',
    templateUrl: './shared.active.slots.item.header.html',
    styleUrls: ['./shared.active.slots.item.header.scss'],
    animations: [fadeInOut]
})
export class SharedActiveSlotsItemHeader implements OnInit {

    public useIonic: boolean = false;
    constructor(@Inject('HomeController') protected homeController: HomeController,
        @Inject('AlertService') public alertService: AlertService,
        protected router: Router,
        protected slotController: SlotsController) {

        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();

    }

    private _route: RouteCardItemDto;
    @Input()
    set route(value: RouteCardItemDto) {
        if (this._route === value)
            return;
        this._route = value;
        this.obtainValues();
    }
    get route(): RouteCardItemDto {
        return this._route;
    }

    public manualTags: HTags;
    public userTags: HTags;
    public internalTags: HTags;
    public privateTags: HTags;
    public stops: HTags;

    showAssignedSlots: boolean;
    firstAssignedSlotDate: String;
    firstAssignedSlotInterval: string;
    tooltipAssignedSlots: string;
    additionalInformation: string;
    slotsInfo: SlotInfoDto[];
    private obtainValues() {
        if (this._route != null) {
            if (this._route.assignedSlots != null && this._route.assignedSlots.length > 0) {

                this.slotsInfo = new Array();
                this._route.assignedSlots.forEach(element => {
                    this.slotsInfo.push(element);
                });


                this.showAssignedSlots = true;
                let s: SlotInfoDto = this._route.assignedSlots[0];
                this.firstAssignedSlotDate = SlotInfoDto.toDateString(s);
                if (!s.multiSlot) {
                    this.firstAssignedSlotInterval = SlotInfoDto.toHourIntervalsString(s);
                    this.additionalInformation = SlotInfoDto.getAdditionalInformation(this._route.assignedSlots);
                    this.tooltipAssignedSlots = SlotInfoDto.toToolTipTextString(this._route.assignedSlots);
                } else {
                    this.slotController.getMultiSlotInfo(s.slotId).subscribe(data => {

                        this.firstAssignedSlotInterval = MultiSlotInfoDto.toHourIntervalsString(data);
                        this.additionalInformation = MultiSlotInfoDto.getAdditionalInformation(data);
                        this.tooltipAssignedSlots = MultiSlotInfoDto.toToolTipTextString(data);

                    });
                }
            } else {
                this.showAssignedSlots = false;
                this.firstAssignedSlotDate = null;
                this.firstAssignedSlotInterval = "";
                this.tooltipAssignedSlots = "";
                this.additionalInformation = "";
            }

            this.manualTags = !HTags.isEmpty(this._route.stops) ? HTags.buildFromDto(this._route.stops) : new HTags();
            this.manualTags.addAll(this._route.manualTags);
            this.userTags = !HTags.isEmpty(this._route.userTags) ? this._route.userTags : null;
            this.internalTags = !HTags.isEmpty(this._route.internalTags) ? this._route.internalTags : null;
            this.privateTags = !HTags.isEmpty(this._route.privateTags) ? this._route.privateTags : null;
        }
        else {
            this.showAssignedSlots = false;
            this.firstAssignedSlotDate = null;
            this.firstAssignedSlotInterval = "";
            this.tooltipAssignedSlots = "";
        }
    }

    getTextColor(data: HColor) {
        if (data != null)
            return HColor.getWhiteBlackFromColor(data.web);

        return HColor.getWhiteBlackFromColor(HColor.defaultColor().web);
    }

    getBackColor(data: HColor) {
        return HColor.getColorOrDefaultColor(data, HColor.defaultColor().web);
    }

    public haveTags(tags: HTags): boolean {
        if (HTags.isEmpty(tags))
            return false;
        return true;
    }

    public goToActiveRoute() {
        if (this.route) {
            if (!this.useIonic)
                window.open(this.homeController.createRouteIdLinkToActiveRoutes(this.route.routeId), '_blank');
            else
                this.router.navigateByUrl(this.homeController.createRouteIdLinkToActiveRoutesMobile(this.route.routeId));
        }
    }
    ngOnInit(): void {
        setTimeout(() => {
            this.showTimeline = false;
        }, 3000);
    }

    public showTimeline: boolean = true;
    toggleView() {
        this.showTimeline = !this.showTimeline;
    }

    copy(value: string) {
        if (value != null && value != "")
            this.alertService.copyToClipboard(value).subscribe(e => { });
    }
    public goToBooking() {
        if (this.route != null)
            this.homeController.goToBooking(this.route.bookingId);
    }
    pretty(value: any): string {
        return JSON.stringify(value);
    }
}
